import React from "react";

// A clean, premium playing-card visual (not a real card library - SVG inspired)
export default function PlayingCard({
    rank = "A",
    suit = "♠",
    red = false,
    isPower = false,
    faceDown = false,
}) {
    const color = red ? "#C2412D" : "#0B0F0D";

    if (faceDown) {
        return (
            <div className="h-full w-full rounded-2xl bg-[#0B4A34] border-[3px] border-[#062A1E] shadow-inner flex items-center justify-center">
                <div className="h-[80%] w-[80%] rounded-xl border-2 border-[#C8A24A]/60 bg-[repeating-linear-gradient(45deg,#0F6244_0_8px,#0B4A34_8px_16px)] flex items-center justify-center">
                    <div className="font-logo text-[#E0C06A] text-xl">GPP</div>
                </div>
            </div>
        );
    }

    if (isPower) {
        return (
            <div className="h-full w-full rounded-2xl bg-gradient-to-br from-[#0B4A34] to-[#062A1E] border-[3px] border-[#C8A24A] shadow-[0_18px_50px_rgba(6,42,30,0.4)] flex flex-col items-center justify-center p-3 text-center">
                <div className="text-[#E0C06A] text-4xl sm:text-5xl drop-shadow">
                    ⚡
                </div>
                <div className="font-display text-[#FBF7EE] text-xl sm:text-2xl mt-1 tracking-wide">
                    POWER PLAY
                </div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.2em] text-[#E0C06A]">
                    Activate
                </div>
            </div>
        );
    }

    return (
        <div className="h-full w-full rounded-2xl bg-[#FBF7EE] border-[3px] border-[#E9D9C1] shadow-inner p-2.5 flex flex-col justify-between">
            <div
                className="flex items-center justify-between"
                style={{ color }}
            >
                <div className="text-xl sm:text-2xl font-extrabold leading-none">
                    {rank}
                </div>
                <div className="text-lg sm:text-xl leading-none">{suit}</div>
            </div>
            <div
                className="text-4xl sm:text-6xl text-center font-extrabold leading-none"
                style={{ color }}
            >
                {suit}
            </div>
            <div
                className="flex items-center justify-between rotate-180"
                style={{ color }}
            >
                <div className="text-xl sm:text-2xl font-extrabold leading-none">
                    {rank}
                </div>
                <div className="text-lg sm:text-xl leading-none">{suit}</div>
            </div>
        </div>
    );
}
